// extracted by mini-css-extract-plugin
module.exports = {"wrapperSpinner":"styles_wrapperSpinner__2mMx7","spinner":"styles_spinner__3sRoU","wrapperSpinnerSmall":"styles_wrapperSpinnerSmall__3Yn0f"};